import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import AddIcon from '@material-ui/icons/Add';

import amber from '@material-ui/core/colors/amber';

import { WebsiteServiceCard } from '../Services';
import Illustration from 'components/Illustration';

const styles = theme => ({
  root: {

  },
  button: {
    backgroundColor: amber[500],
    color: "#fff",
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  content: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
  }
});

const WebsiteServiceCards = ({ classes, services, handleDialog }) => {
  return(
    <div>
      <div className={classes.header}>
        <div>
          <Typography variant="headline">
            Services
          </Typography>
          <Typography variant="caption">
            The type of work you offer, let them know what you can do.
          </Typography>
        </div>
        <Button
          className={classes.button}
          variant="fab"
          aria-label="add"
          onClick={() => handleDialog({show: true})}
          >
          <AddIcon />
        </Button>
      </div>
      <div className={classes.content}>
        {services.length > 0 &&
          services.map((service, i) => {
            return <WebsiteServiceCard
                      key={i}
                      service={service}
                      handleDialog={handleDialog}
                    />
          })
        }
        {services.length === 0 &&
          <Illustration
            imgKey="superhero_amber"
            explainerText="Let your future clients know what you do! All the services you add here will show up on your website"
            addItemText="Let’s get them entered by clicking the “Floating Action Button” at top right."
          />
        }
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const services = state.websiteState.services;
  return({
    services
  });
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps),
)(WebsiteServiceCards);



// WEBPACK FOOTER //
// ./src/components/admin/Website/Services/WebsiteServiceCards.jsx